import script from "./SingleActivitySection.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleActivitySection.vue?vue&type=script&setup=true&lang=js"

import "./SingleActivitySection.vue?vue&type=style&index=0&id=8c03c42e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c03c42e"]])

export default __exports__